exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination-container[data-v-45298bee]  .el-pagination{text-align:right}", ""]);

// exports
